import { MANUALLY_SELECTED_ORGANIZATION } from '@backoffice-frontend/common'
import { useLocalStorage } from '@backoffice-frontend/hooks'
import { Option, Select } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { useOrganizations } from './useOrganizations'

export const OrganizationSelector = ({
  onOrganizationChange,
}: {
  onOrganizationChange: () => void
}) => {
  const { t } = useTranslation()
  const { organizations } = useOrganizations()
  const [selectedOrganization, setSelectedOrganization] = useLocalStorage(
    MANUALLY_SELECTED_ORGANIZATION,
    'moia',
  )

  const handleOrganizationChange = (value: string) => {
    setSelectedOrganization(value)
    onOrganizationChange()
  }

  const selectedOption = organizations.find(
    org => org.subdomain === selectedOrganization,
  )

  return (
    <Select
      aria-label={t('loginView_organizationSelector')}
      size="compact"
      placeholder={t('loginView_organizationSelector')}
      onChange={handleOrganizationChange}
      value={selectedOption?.name ?? ''}
      options={
        <>
          {organizations.map(organization => (
            <Option key={organization.subdomain} value={organization.subdomain}>
              {organization.name}
            </Option>
          ))}
        </>
      }
    />
  )
}
